import { Signal, computed } from '@angular/core';

export abstract class BaseLocalizedPlaceholderFormatPipe<T> {
  protected abstract transform(value: T): string;
  protected abstract getPlaceholderInput(): T;
  abstract toFormattedSignal(value: T): Signal<string>;

  private readonly placeholderInput = this.getPlaceholderInput();

  public readonly placeholderSignal = computed(() => {
    const formatted = this.transform(this.placeholderInput);
    return formatted.replace(/[\p{L}\p{N}]/gu, '-');
  });
}
